namespace TabAurous.OMS {
    export interface LedgerPostingRow {
        LedgerPostingId?: number;
        TransId?: number;
        RefTransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        LedgerId?: number;
        LedgerName?: string;
        AccountGroupId?: number;
        Debit?: number;
        Credit?: number;
        CCDebit?: number;
        CCCredit?: number;
        ExchangeRate?: number;
        CurrencyId?: number;
        DBalance?: number;
        CBalance?: number;
        DrCr?: string;
        DetailsId?: number;
        FinancialYearId?: number;
        CompanyId?: number;
        InvoiceNo?: string;
        ChequeNo?: string;
        ChequeDate?: string;
        POSCustomerId?: number;
        BaseItemTypeId?: number;
        MDebit?: number;
        MCredit?: number;
        OpeningBalance?: string;
        Balance?: string;
        GroupName?: string;
        PartyCode?: string;
        OpBalance?: string;
        Balance1?: string;
        Nature?: string;
        Amount1?: number;
        Amount2?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace LedgerPostingRow {
        export const idProperty = 'LedgerPostingId';
        export const nameProperty = 'LedgerName';
        export const localTextPrefix = 'OMS.LedgerPosting';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            LedgerPostingId = "LedgerPostingId",
            TransId = "TransId",
            RefTransId = "RefTransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            AccountGroupId = "AccountGroupId",
            Debit = "Debit",
            Credit = "Credit",
            CCDebit = "CCDebit",
            CCCredit = "CCCredit",
            ExchangeRate = "ExchangeRate",
            CurrencyId = "CurrencyId",
            DBalance = "DBalance",
            CBalance = "CBalance",
            DrCr = "DrCr",
            DetailsId = "DetailsId",
            FinancialYearId = "FinancialYearId",
            CompanyId = "CompanyId",
            InvoiceNo = "InvoiceNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            POSCustomerId = "POSCustomerId",
            BaseItemTypeId = "BaseItemTypeId",
            MDebit = "MDebit",
            MCredit = "MCredit",
            OpeningBalance = "OpeningBalance",
            Balance = "Balance",
            GroupName = "GroupName",
            PartyCode = "PartyCode",
            OpBalance = "OpBalance",
            Balance1 = "Balance1",
            Nature = "Nature",
            Amount1 = "Amount1",
            Amount2 = "Amount2",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
